import React, { useCallback, useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Button,
  AppBar,
  Tab,
  Tabs,
  Box,
} from "@material-ui/core";
import { TabPanel, TabList, TabContext } from "@material-ui/lab";
import { useCustomerEditStyles } from "../../Util/CSS/CustomerEdit/CustomerEdit";
import { withRouter } from "react-router-dom";
import OpenSnackbar from "../../Shared/OpenSnackbar";
import LoadingScreen from "../../Shared/LoadingScreen";
import CustomerDetails from "./CustomerDetails";
import OrderHistory from "./OrderHistory";
import axios from "axios";
import { makeStyles } from "@material-ui/styles";
import LoadMoreItems from "../../Shared/LoadMoreItemsScreen";
const useStyles = makeStyles({
  buttonStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "80%",
    "&:hover": {
      background: "#6be8c6",
    },
  },
  dflex: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "40px",
  },
});
const CustomerEdit = ({ match }) => {
  const classes = useCustomerEditStyles();
  const styles = useStyles();
  const { params } = match;
  const { id } = params;
  const [loadingMoreItems, setLoadingMoreItems] = useState(false);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isClicked, setIsClicked] = useState("0");
  const [lastEvaluatedKey, setLastEvaluatedKey] = useState(null);
  const [orders, setOrders] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [snackbarDetails, setSnackbarDetails] = useState({
    message: "",
    type: "",
  });

  const handleSnackbarOpen = (message, type) => {
    let obj = {
      message,
      type,
    };
    setSnackbarDetails(obj);
    setSnackbarOpen(true);
  };

  const [customerData, setCustomerData] = useState({});
  const enableScroll = () => {
    window.onscroll = function () {};
  };
  const disableScroll = () => {
    let TopScroll = window.pageYOffset || document.documentElement.scrollTop;
    let LeftScroll = window.pageXOffset || document.documentElement.scrollLeft;
    window.onscroll = function () {
      window.scrollTo(LeftScroll, TopScroll);
    };
  };

  useEffect(() => {
    window.onscroll = () => {
      if (
        orders.length > 0 &&
        window.innerHeight + window.scrollY + 1000 >=
          document.body.offsetHeight &&
        isClicked === "1" &&
        lastEvaluatedKey !== undefined
      ) {
        getCustomerData();
      }
    };
  });

  const getCustomerData = async () => {
    disableScroll();
    if (!isLoaded) {
      setLoading(true);
    } else {
      setLoadingMoreItems(true);
    }
    if (id) {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}customer/${id}`,
          {
            lastEvaluatedKey: lastEvaluatedKey,
            limit: 50,
          }
        );
        if (res) {
          setCustomerData(res.data);
          let orderClone = [...orders, ...res.data.orderHistory];
          orderClone.flat();
          orderClone.sort((a, b) => b.readable_id - a.readable_id);
          setLastEvaluatedKey(res.data?.lastEvaluatedKey || undefined);
          setOrders([...orderClone]);
        }
      } catch (error) {
        if (error?.response?.data?.error) {
          handleSnackbarOpen(error?.response?.data?.error, "errorDark");
        }
        if (error?.message) {
          handleSnackbarOpen(error?.message, "errorDark");
        }
        setLoading(false);
      } finally {
        setIsLoaded(true);
        setLoading(false);
        setLoadingMoreItems(false);
        enableScroll();
      }
    }
  };
  useEffect(() => {
    getCustomerData();
  }, []);
  const handleChange = (e, newValue) => {
    setIsClicked(newValue);
  };
  return (
    <>
      {loading ? (
        <LoadingScreen loading={loading} />
      ) : (
        <TabContext value={isClicked}>
          <Box>
            {loadingMoreItems && <LoadMoreItems loading={loadingMoreItems} />}
            <TabList onChange={handleChange}>
              <Tab label="Profile" value="0" />
              <Tab
                label="Order History"
                value="1"
                data-testid="order_history_btn"
              />
            </TabList>
            <TabPanel value="0">
              <CustomerDetails
                classes={classes}
                customerData={customerData}
                id={id}
                setCustomerData={setCustomerData}
              />
            </TabPanel>
            <TabPanel value="1">
              {orders.length > 0 ? (
                <OrderHistory classes={classes} orders={orders} />
              ) : (
                <h2 className={styles.dflex}>
                  Sorry, no order found of this customer!
                </h2>
              )}
            </TabPanel>
          </Box>
        </TabContext>
      )}
      {snackbarOpen && (
        <OpenSnackbar
          message={snackbarDetails.message}
          type={snackbarDetails.type}
          open={snackbarOpen}
          setOpen={setSnackbarOpen}
          vertical="bottom"
          horizontal="center"
        />
      )}
    </>
  );
};

export default withRouter(CustomerEdit);
